import React, { Component } from "react"
import { BUSY, WAITING } from "../constants/status"

const DEFAULT_TIME = 180
const COLORS = ['#f44336', '#ff9800', '#ffeb3b', '#78d600']

class Timing extends Component {

    constructor() {
        super()

        this.state = {
            counter: DEFAULT_TIME,
            hidden: false
        }

        this._timer = null
    }

    componentDidMount = () => {
        this.start()
    }

    componentWillUnmount = () => {
        this.stop()
    }

    /* Start interval */
    start = () => {
        if (!this._timer) {
            this._timer = setInterval(this.countDown, 1000)
        }
    }

    /* Stop interval */
    stop = () => {
        if (this._timer) {
            clearInterval(this._timer)
            this._timer = null
        }
    }

    /* Count Down action */
    countDown = () => {

        const { counter } = this.state
        const { status, isPaused, setUserTime } = this.props

        if (isPaused || (status === BUSY || status === WAITING)) {
            return
        }

        const nextSecond = counter - 1

        if (nextSecond <= 0) {
            this.setState({ counter: 0 })
            this.stop()
            return
        }

        this.setState({ counter: nextSecond })
        setUserTime && setUserTime(nextSecond)
    }

    /* Hide timer (стол на удержании) */
    hide = () => {
        this.stop()
        this.setState({ hidden: true })
    }

    /* Reset timer to a new value (также снова показывает таймер) */
    reset = (counter) => {
        this.setState({ counter, hidden: false }, () => {

            if (counter <= 0) {
                this.stop()
                return
            }

            // Всегда гарантируем, что таймер снова работает
            this.stop()
            this.start()
        })
    }

    /* Get color */
    getColor = () => {
        const { counter } = this.state
        const size = COLORS.length

        const index = Math.floor(counter / DEFAULT_TIME * size)

        if (COLORS[index]) {
            return COLORS[index]
        }

        return COLORS[size - 1]
    }

    render = () => {
        const { counter, hidden } = this.state

        /* На удержании таймер скрыт */
        if (hidden) {
            return null
        }

        const color = this.getColor()

        return (
            <div className={`top-timing-box ${counter <= 10 ? 'top-ending-timing-box' : ''}`}>
                <div className={`top-timing ${counter <= 10 ? 'top-ending-timing' : ''}`}
                    style={{ width: `calc(100% * ${counter / DEFAULT_TIME})`, background: color }} />
                <div className="top-timing-text">
                    Примите ваше решение: {counter}
                </div>
            </div>
        )
    }
}

export default Timing
